import { formatNumber } from '@/lib/utils';

interface TweetMetaProps {
  date: string;
  likes: number;
  retweets: number;
  tweetUrl?: string;
}

export function TweetMeta({ date, likes, retweets, tweetUrl }: TweetMetaProps) {
  return (
    <div className="tweet-meta flex items-center gap-5 mt-3 pt-3 border-t border-border">
      <span className="tweet-date text-text-muted text-sm">{date}</span>
      {tweetUrl && (
        <a
          href={tweetUrl}
          target="_blank"
          rel="noopener"
          className="text-accent hover:underline text-sm"
        >
          View on Twitter
        </a>
      )}
      <div className="tweet-stats flex gap-4 ml-auto">
        <span className="tweet-stat likes flex items-center gap-1 text-like text-sm">
          <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
          </svg>
          {formatNumber(likes)}
        </span>
        <span className="tweet-stat flex items-center gap-1 text-text-secondary text-sm">
          <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
            <path d="M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z" />
          </svg>
          {formatNumber(retweets)}
        </span>
      </div>
    </div>
  );
}
